/**
 * <schu-tooltip> — Light DOM tooltip web component
 *
 * Generates a unique ID and CSS anchor name per instance, avoiding
 * duplicate-id and conflicting anchor-name issues on pages with multiple tooltips.
 *
 * Attributes:
 *   label        – aria-label for the tooltip aside (for screen readers)
 *   icons-href   – path to the SVG sprite file (default: /assets/icons.svg)
 *
 * Usage:
 *   <schu-tooltip label="Pricing details">
 *     <p class="tooltip-content-text">Your tooltip body text here.</p>
 *   </schu-tooltip>
 */
class SchuTooltip extends HTMLElement {
  static #counter = 0;

  connectedCallback() {
    const id = ++SchuTooltip.#counter;
    const tooltipId = `tooltip-content-${id}`;
    const anchorName = `--info-btn-${id}`;
    const label = this.getAttribute('label') || '';
    const icons = this.getAttribute('icons-href') || '/assets/icons.svg';

    // Capture body content before replacing innerHTML
    const bodyContent = this.innerHTML.trim();

    // Set unique anchor name as a CSS custom property so child elements inherit it
    this.style.setProperty('--anchor-name', anchorName);

    this.innerHTML = `
      <div class="tooltip">
        <button class="tooltip-toggle" aria-describedby="${tooltipId}" popovertargetaction="show" type="button" popovertarget="${tooltipId}">
          <svg class="tooltip-toggle-icon">
            <use href="${icons}#fill-info-outline"></use>
          </svg>
        </button>
        <aside class="tooltip-content" id="${tooltipId}" aria-label="${label}" role="tooltip" popover="auto">
          <div class="header">
            <svg class="tooltip-content-icon">
              <use href="${icons}#fill-info-solid"></use>
            </svg>
            <button popovertarget="${tooltipId}" popovertargetaction="hide" class="close-button">
              <svg class="tooltip-content-icon">
                <use href="${icons}#stroke-close-x"></use>
              </svg>
            </button>
          </div>
          ${bodyContent}
        </aside>
      </div>
    `;
  }
}

export function registerTooltipElement()
{
  customElements.define('schu-tooltip', SchuTooltip);
}
